import type { Favorite } from '@/Ship/Stores/FavoritesManager'

/**
 * Пошук у шухляді «Обране» — на льоту за назвою й коментарем, без запиту:
 * список уже весь у сторі (`SPEC-014` §4.4, Д5). Регістр згортаємо локаллю
 * `uk` — «Альфа» знаходиться за «альф».
 */
export const matchesFavorite = (item: Pick<Favorite, 'title' | 'comment'>, query: string): boolean => {
    const needle = query.trim().toLocaleLowerCase('uk')

    if (!needle) return true

    return [item.title, item.comment ?? ''].some((text) => text.toLocaleLowerCase('uk').includes(needle))
}
